<div class="modal-body">
  <img class="image-2" src="/assets/svg/Attention-pix.svg" alt="info-image">
  <h1>Atenção</h1>
  <p>Para sua segurança o aumento do seu limite máximo diário pode ser solicitado apenas ao seu gerente. Por favor, entre em contato com ele e peça essa alteração.</p>
  <button type="button" class="button-primary"  (click)="closeModal($event)">
    Fechar
  </button>
</div>
